<!--能源走势（柱状图，横向比例图）-->
<template>
<div class="energytrend commonborder flex_column">
  <div class="tabs" v-if="isShowActive">
    <li v-for="(item,index) in tabslist" :key="index" :class="item.id == tabsid ? 'active' : ''" @click="tabChange(item.id)">{{item.text}}</li>
  </div>
  <div class="tabs" v-else>
    <li v-for="(item,index) in tabslist" :key="index" :class="item.id == tabsid ? 'active' : ''" @click="tabChangeDay(item.id)">{{item.text}}</li>
  </div>
  <div class="type" style="z-index:99">
    <li :class="isShowActive?'active':''" @click="isShowActive=true,tabsid=1,getList(1),getListAll()">按月</li>
    <li :class="!isShowActive?'active':''" @click="isShowActive=false,tabsid=1,getListDay(1),getListDayAll()">按日</li>
  </div>
  <div v-if="isShowActive" style="height:100%">
    <!-- 按月 -->
    <div id="energytrend_bar1" class="echarts"></div>
    <div class="bottom">
      <div id="energytrend_bar2" class="echarts"></div>
      <ul>
        <li>电力{{power}}%</li>
        <li>水力{{water}}%</li>
        <li>燃气{{gas}}%</li>
        <li>燃煤{{coal}}%</li>
        <li>燃油{{oil}}%</li>
      </ul>
    </div>
  </div>
  <!-- 按日 -->
  <div v-else style="height:100%">
    <div id="energytrend_bar1" class="echarts"></div>
    <div class="bottom">
      <div id="energytrend_bar2" class="echarts"></div>
      <ul>
        <li>电力{{power}}%</li>
        <li>水力{{water}}%</li>
        <li>燃气{{gas}}%</li>
        <li>燃煤{{coal}}%</li>
        <li>燃油{{oil}}%</li>
      </ul>
    </div>
  </div>
</div>
</template>

<script>
import api from '@/apis/power/power';
let echarts = require("echarts/lib/echarts");
export default {
  data() {
    return {
      isShowActive:true,

      power:'',
      water:'',
      gas:'',
      coal:'',
      oil:'',
      tabsid:1,
      tabslist:[
        {id:1,text:'电'},
        {id:2,text:'水'},
        {id:3,text:'气'},
        {id:4,text:'煤'},
        {id:5,text:'油'}
        // {id:1,text:'电/KWH'},
        // {id:2,text:'水/T'},
        // {id:3,text:'气/m³'},
        // {id:4,text:'煤/T'},
        // {id:5,text:'油/L'}
      ],
    };
  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  methods: {
    //tab切换
    tabChange(ind){
      this.tabsid = ind
      this.getList(ind)
    },
    tabChangeDay(ind){
      this.tabsid = ind
      this.getListDay(ind)
    },
    //获取日数据占比
    getListDayAll(){
      api.getTrendDayList().then(res=>{
        if(res.code==10000){
          // 柱状图占比
          if(res.data){
            let _data = JSON.parse(res.data.jsonData)
            let _sumArr = []
            let _totalSum = 0
            for(var k in _data){
              let _powerSum = 0
              for(var k1 in _data[k].dayDates){
                if(!_data[k].dayDates[k1].sum){
                  _data[k].dayDates[k1].sum = 0
                }
                _powerSum+=parseInt(_data[k].dayDates[k1].sum)
              }
              _sumArr.push(_powerSum)
              _totalSum+=_powerSum
            }
            this.power = (_sumArr[0]/_totalSum*100).toFixed(0)
            this.water = (_sumArr[1]/_totalSum*100).toFixed(0)
            this.gas = (_sumArr[2]/_totalSum*100).toFixed(0)
            this.coal = (_sumArr[3]/_totalSum*100).toFixed(0)
            this.oil = (_sumArr[4]/_totalSum*100).toFixed(0)
            this.energytrend_bar2(
              this.power,
              this.water,
              this.gas,
              this.coal,
              this.oil,
            )
          }
        }else{
          this.$message.error(res.message);
          return;
        }
      })
    },
    //获取数据柱状图日数据
    getListDay(tabs){
      api.getTrendDayList().then(res=>{
        if(res.code==10000){
          if(res.data){
            let _data = JSON.parse(res.data.jsonData)
            for(var i in _data){
              if(tabs==_data[i].type){
                let _arr = []
                let _arrLast = []
                for(var j in _data[i].dayDates){
                  _arr.push(_data[i].dayDates[j].sum)
                }
                for(var s in _data[i].dayDatesLast){
                  _arrLast.push(_data[i].dayDatesLast[s].sum)
                }
                this.energytrend_bar1(_arr,_arrLast)
              }
            }
          }
        }
      })
    },
    //获取数据柱状图
    getList(tab){
      api.getBatch({
        collect:'',
        type:tab?tab:1,
        time:new Date().getFullYear()
      }).then(res=>{
        if(res.code==10000){
          if(res.data.data.length!=0){
            let _data = res.data.data[0]
            let _last = res.data.data[0].lastData
            let thisArr = [
              _data.oneData,
              _data.twoData,
              _data.threeData,
              _data.fourData,
              _data.fiveData,
              _data.sixData,
              _data.sevenData,
              _data.eightData,
              _data.nineData,
              _data.tenData,
              _data.elevenData,
              _data.twelveData,
            ];
            let lastArr = [
              _last.oneData,
              _last.twoData,
              _last.threeData,
              _last.fourData,
              _last.fiveData,
              _last.sixData,
              _last.sevenData,
              _last.eightData,
              _last.nineData,
              _last.tenData,
              _last.elevenData,
              _last.twelveData,
            ]
            this.energytrend_bar1(thisArr,lastArr)
          }
        }
      })
    },
    //获取数据占比
    getListAll(){
      api.getBatch({
        collect:'',
        type:'',
        time:new Date().getFullYear()
      }).then(res=>{
        if(res.code==10000){
          let _data = res.data
          let total = _data.zb.total
          if(_data.data.length!=0){
            this.power = (_data.zb.power/total*100).toFixed(0)
            this.water = (_data.zb.water/total*100).toFixed(0)
            this.gas = (_data.zb.gas/total*100).toFixed(0)
            this.coal = (_data.zb.coal/total*100).toFixed(0)
            this.oil = (_data.zb.oil/total*100).toFixed(0)
            this.energytrend_bar2(
              this.power,
              this.water,
              this.gas,
              this.coal,
              this.oil,
            )
          }
        }else{
          this.$message.error(res.message);
          return;
        }
      })
    },
    energytrend_bar1(a,b){
      let energytrend_bar1 = echarts.init( document.getElementById('energytrend_bar1') );     
      energytrend_bar1.setOption({
          tooltip: { trigger: 'axis',textStyle:{fontSize: this.$echartsFontSize},
            axisPointer: {
              type: 'shadow'
            }
          },
          // legend: {
          //     data: ['去年', '今年'],
          //     top:15,
          //     textStyle: {
          //         color: "#fff",fontSize:this.$echartsFontSize
          //     },
          //     itemWidth: 15,
          //     itemHeight: 5,
          // },
          xAxis: {
              type: 'category',
              axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
              axisLine:{lineStyle:{color:this.axisLineColor}},
              axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
              data:this.isShowActive?['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']:
              ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31']
          },
          yAxis: {
              axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
              axisLine:{lineStyle:{color:this.axisLineColor}},
              splitNumber:3,
              splitLine:{show:true,lineStyle:this.splitLineStyle},
          },
          grid: { left: '4%',right:'4%',top:'25%',bottom:'0',containLabel: true},
          series: [
            {
              name: '去年',
              type: 'line', showSymbol:false,smooth:true,
              itemStyle: {
                  normal: {
                      color: '#00ccff',
                      lineStyle: {
                          color: "#00ccff",
                          width: 2
                      },
                  }
              },
              areaStyle: {
                  //折线图颜色半透明
                  color: {
                      type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                      colorStops: [{
                          offset: 0, color: 'rgba(0,204,255, 1)' // 0% 处的颜色
                      }, {
                          offset: 1, color: 'rgba(0,204,255, .1)' // 100% 处的颜色
                      }],
                      global: false // 缺省为 false
                  }
              },
              data:a
            },
            {
              name: '今年',
              type: 'line',showSymbol:false,smooth:true,
              itemStyle: {
                  normal: {
                      color: '#24ffb1',
                      lineStyle: {
                          color: "#24ffb1",
                          width: 2
                      },
                  }
              },
              areaStyle: {
                  //折线图颜色半透明
                  color: {
                      type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                      colorStops: [{
                          offset: 0, color: 'rgba(36,255,177, 1)' // 0% 处的颜色
                      }, {
                          offset: 1, color: 'rgba(36,255,177, .1)' // 100% 处的颜色
                      }],
                      global: false // 缺省为 false
                  }
              },
              data: b
            },
          ]
      })
      this.$common.moveEcharts(this.isShowActive? 12 : 31,energytrend_bar1);
    },
    energytrend_bar2(a,b,c,d,e){
      let energytrend_bar2 = echarts.init( document.getElementById('energytrend_bar2') );
      energytrend_bar2.setOption({
          color:['#1abad8','#34d795','#eaed83','#186cb2','#f14141'],
          grid: {
              left: '10', right: '10',top:'40%',bottom:'6'
          },
          xAxis: {
            type: 'value',show:false,
            max: 100,
          },
          yAxis: {
              type: 'category',show:false
          },
          series: [
              {
                  name: '电力', type: 'bar', stack: 'total',
                  data: [a]
              },
              {
                  name: '水力', type: 'bar', stack: 'total',
                  data: [b]
              },
              {
                  name: '燃气', type: 'bar', stack: 'total',
                  data: [c]
              },
              {
                  name: '燃煤', type: 'bar', stack: 'total',
                  data: [d]
              },
              {
                  name: '燃油', type: 'bar', stack: 'total',
                  data: [e]
              }
          ]
      })
    },
  },
  mounted() {
    this.getList()
    this.getListAll()
  },
};
</script>

<style lang="less" scoped>
.energytrend{
  #energytrend_bar1{ height: 75%;}
  .bottom{ height: 25%;
    #energytrend_bar2{ height: 50%;}
    ul{
      li{ display: inline-block; width: 20%; text-align: center; font-size: .68rem;}
      li::before{ content: ' '; position: relative; display: inline-block; width: .5rem; height:.5rem; margin-right: 6px; background: #1abad8;}
      li:nth-child(2)::before{ background: #34d795;}
      li:nth-child(3)::before{ background: #eaed83;}
      li:nth-child(4)::before{ background: #186cb2;}
      li:nth-child(5)::before{ background: #f14141;}
    }
  }

  .tabs{
    position:absolute; z-index: 99;  border: #063fb6 solid 1px; top: -1.2rem; right: .2rem;
    li{ font-size: .75rem; padding:4px 15px; display: inline-block; position: relative; cursor: pointer; transition: all 1s ease 0s;}
    li::after{ content: ' '; position: absolute; opacity: 0; bottom: 0; left: 35%; width: 0; height: 0; border-style: solid; border-width: 8px; border-color: transparent transparent #00f6ff transparent;}
    li.active{ color: #fff; background: #36f;}
    // li.active::after{ opacity: 1;}
    // li:hover::after{ opacity: 1;}
  }

  .type{ position: absolute; top:.3rem; left:0rem;
    li{ padding:0 .4rem; position: relative; display: inline-block; cursor: pointer;}
    li::before{ content: ' '; display: inline-block; vertical-align: middle; margin-right: 8px; width: .5rem; height: .5rem; border-radius: 50%; border: #ccd0f2 solid 2px;}
    li.active{ color: #24ffb1;}
    li.active::before{ border-color: #24ffb1;}
    li.active::after{ content: ' '; position: absolute; top:0.4rem; left:.6rem; width: .3rem; height: .3rem; background: #24ffb1; border-radius: 50%;}
  }


}
</style>